export default {"src":"/_next/static/media/basescan.5f06068d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};